import { render } from "./NYFormPage.vue?vue&type=template&id=e8c8b796"
import script from "./NYFormPage.vue?vue&type=script&lang=js"
export * from "./NYFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__